/*****General Variables******/
const siteUrl = 'https://community-wp.ciisummit.com';
const hostUrl = 'community-wp.ciisummit.com';
//const wsUrl = 'ws://127.0.0.1:8080';
const wsUrl = 'wss://ws.ciisummit.com';
const vipTokenString = 'eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ';

/*****Login screen messages********/
const loginSuccess = "Login Successful"
const highTrafficLogin = "Due to heavy traffic on the website, we have failed to log you in at this moment. Please try logging in after some time";
const invalidUsername = 'Invalid Username';
const invalidPassword = 'Invalid Password';
const passwordWeak  = 'Password Strength Weak: input at least 6 characters including alphabets, numbers & special characters';
const passwordMedium  = 'Password Strength Medium: input at least 6 characters including alphabets, numbers & special characters';
const confirPasswordNotMatched = "Passwords didn't match";
const tokenExpiredLoginAgain = 'Session Timeout. Please Login again!';
/*****Inner Pages******/
const highTrafficInnerPages = "This page failed to load due to high traffic at this moment. Please visit again after some time";
const themeDefault = 'dark'
const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

export {tokenExpiredLoginAgain, vipTokenString, wsUrl, hostUrl, siteUrl, loginSuccess, highTrafficLogin, invalidUsername, invalidPassword, passwordWeak, passwordMedium, confirPasswordNotMatched, highTrafficInnerPages,  themeDefault, namesOfModes }